import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DeleteTimeSurveyDocumentRequest, TimeSurveyDocument } from 'src/app/survey/models/survey-document.model';
import { API_URL } from '../../constants/apiurl-constants';
import { SessionService } from '../../session-service/session.service';

@Injectable({ providedIn: 'root' })
export class TimeSurveyDocumentService {
  private surveyDocuments = new BehaviorSubject<TimeSurveyDocument[]>([]);
  surveyDocument$ = this.surveyDocuments.asObservable();

  constructor(private _sessionService: SessionService) { }

  getEmployeeDocuments(engagementId: any, surveyId: any, employeeId: any) {
    return this._sessionService.apiUrlGet(API_URL.DOCUMENT.GETEMPLOYEEDOCUMENTS + '?engagementId=' + engagementId +
      '&surveyId=' + surveyId + '&employeeId=' + employeeId);
  }

  setTimeSurveyDocumentUpload(timeSurveyUploadedDocuments: TimeSurveyDocument[]): void {
    this.surveyDocuments.next(timeSurveyUploadedDocuments);
  }

  deleteTimeSurveyDocument(deletedDoc: DeleteTimeSurveyDocumentRequest) {
    return this._sessionService.apiUrlPost(API_URL.DELETE_TIME_SURVEY_DOCUMENT, deletedDoc);
  }

  getSurveysOnlyByEngagement(engagementId){
    let url = API_URL.GETSURVEYSONLYBYENGAGEMENTID;
    return this._sessionService.apiUrlGet(url + `?engagementId=${engagementId}`);
  }

  // downloadDocument(documentIds: any) {
  //   return this._sessionService.downloadAsFile(
  //     API_URL.DOCUMENT.DOWNLOADOCUMENTS,
  //     documentIds
  //   );
  // }

  downloadTimeSurveyDocument(documentId: number, surveyId: number, engagementId, employeeId: number = 0) {
    const downloadFileUrl = API_URL.DOWNLOAD_TIME_SURVEY_DOCUMENT + `?documentId=${documentId}&surveyId=${surveyId}&engagementId=${engagementId}&employeeId=${employeeId}`;
    return this._sessionService.downloadAsFileGet(downloadFileUrl);
  }
}
